export const structure = () => {
    return {
        loaded: 0, // 0 - not loaded yet, 1 - loaded only one based on url request, 2 - fully loaded
        npk: '',
        lastSync: '',
        filters: {},
        hash: '',
        total: 0,
        data: {}
    }
}

export default {
    campuses: structure(),
    utilities: structure(),
    transits: structure()
}
